export const retro = [
  { char: '📻', name: 'Radio', nameZh: '收音機', keywords: ['music', 'old', 'classic', '復古'] },
  { char: '📺', name: 'TV', nameZh: '電視機', keywords: ['show', 'old', 'retro', '經典'] },
  { char: '📼', name: 'VHS', nameZh: '錄影帶', keywords: ['movie', 'old', 'memory', '懷舊'] },
  { char: '📷', name: 'Camera', nameZh: '相機', keywords: ['photo', 'classic', '紀錄'] },
  { char: '🎞️', name: 'Film Frames', nameZh: '底片', keywords: ['movie', 'photo', 'story', '電影'] },
  { char: '☎️', name: 'Telephone', nameZh: '老電話', keywords: ['call', 'classic', '復古'] },
  { char: '🕰️', name: 'Mantel Clock', nameZh: '老時鐘', keywords: ['time', 'history', '經典'] },
  { char: '🕯️', name: 'Candle', nameZh: '蠟燭', keywords: ['light', 'old', 'mood', '氛圍'] },
  { char: '🏮', name: 'Lantern', nameZh: '燈籠', keywords: ['light', 'asia', 'classic', '傳統'] },
  { char: '📜', name: 'Scroll', nameZh: '捲軸', keywords: ['history', 'write', 'old', '故事'] },
  { char: '✒️', name: 'Nib', nameZh: '鋼筆', keywords: ['write', 'classic', '質感'] },
  { char: '💎', name: 'Gem', nameZh: '寶石', keywords: ['luxury', 'classic', '鑽石'] },
  { char: '🏰', name: 'Castle', nameZh: '城堡', keywords: ['history', 'king', '經典'] },
  { char: '🚂', name: 'Locomotive', nameZh: '蒸氣火車', keywords: ['train', 'old', 'travel'] },
  { char: '🕹️', name: 'Joystick', nameZh: '搖桿', keywords: ['game', 'retro', 'play', '童年'] },
];